import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IScore, ISessionsDashboard} from "../types";

// Define a type for the slice state
interface ScoreState {
    value?: (IScore & { CreatedAt: string })[];
    sessionsDashboard?: ISessionsDashboard
}

// Define the initial state using that type
const initialState: ScoreState = {
    value: undefined,
    sessionsDashboard: {
        numSessions: 0,
        topScore: 0,
        avgScore: 0,
        closedSales: 0,
        closingRate: 0,
        currentStreak: 0,
        bestStreak: 0,
        scoresList: []
    }
} as ScoreState;

export const scoreSlice = createSlice({
    name: 'score',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setScore: (state, action: PayloadAction<ScoreState['value']>) => {
            state.value = action.payload;
        },
        setSessionsDashboard: (state, action: PayloadAction<ScoreState['sessionsDashboard']>) => {
            state.sessionsDashboard = action.payload;
        }
    },
});

export const {setScore, setSessionsDashboard} = scoreSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value;

export default scoreSlice.reducer;
